// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetOrganisationByExternalIdAsyncRequestModel from '../../model/get-organisation-by-external-id-async-request-model';
import GetOrganisationByExternalIdAndEventIdentifierAsyncRequestModel from '../../model/get-organisation-by-external-id-and-event-identifier-async-request-model';
import PostOrganisationRequestModel from '../../model/post-organisation-request-model';
import LookupAllOrganisationsRequestModel from '../../model/lookup-all-organisations-request-model';
import GetOrganisationForUserRequestModel from '../../model/get-organisation-for-user-request-model';
import GetOrganisationsRequestModel from '../../model/get-organisations-request-model';
import GetOrganisationRequestModel from '../../model/get-organisation-request-model';
import PutOrganisationRequestModel from '../../model/put-organisation-request-model';
import LookupRequestModel from '../../model/lookup-request-model';
import Tdg_OrganisationUpdateModel from '../../model/tdg-organisation-update-model';
import Tdg_OrganisationEventModel from '../../model/tdg-organisation-event-model';
import Tdg_OrganisationModel from '../../model/tdg-organisation-model';
import Int64LookupListResultModel from '../../model/int64-lookup-list-result-model';
import Tdg_OrganisationListPagingResultModel from '../../model/tdg-organisation-list-paging-result-model';

export default (service: Servicelayer) => ({
  /**  */
  async getOrganisationByExternalIdAsync(request: GetOrganisationByExternalIdAsyncRequestModel, config?: RequestConfig) {
    const requestDTO = GetOrganisationByExternalIdAsyncRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-organisation-by-external-id-async'] ?? 'tdg/widget/organisations/{externalId}';
    endpointPath = endpointPath.replace(/\{externalId\}/g, `${requestDTO.externalId}`);
    const response = await service.get<any>(endpointPath, {
      query: {
        externalId: requestDTO.externalId,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_OrganisationUpdateModel.toModel(dto));
  },
  /**  */
  async getOrganisationByExternalIdAndEventIdentifierAsync(request: GetOrganisationByExternalIdAndEventIdentifierAsyncRequestModel, config?: RequestConfig) {
    const requestDTO = GetOrganisationByExternalIdAndEventIdentifierAsyncRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-organisation-by-external-id-and-event-identifier-async'] ?? 'tdg/widget/organisations/{externalId}/event/{eventIdentifier}';
    endpointPath = endpointPath.replace(/\{externalId\}/g, `${requestDTO.externalId}`);
    endpointPath = endpointPath.replace(/\{eventIdentifier\}/g, `${requestDTO.eventIdentifier}`);
    const response = await service.get<any>(endpointPath, {
      query: {
        externalId: requestDTO.externalId,
        eventIdentifier: requestDTO.eventIdentifier,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_OrganisationEventModel.toModel(dto));
  },
  /**  */
  async postOrganisation(request: PostOrganisationRequestModel, config?: RequestConfig) {
    const requestDTO = PostOrganisationRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-post-organisation'] ?? 'tdg/widget/organisations';
    const response = await service.post<any>(endpointPath, {
      body: {
        organisation: requestDTO.organisation,
        user: requestDTO.user,
      },
      query: {
        eventIdentifier: requestDTO.eventIdentifier,
        existingOrganisationId: requestDTO.existingOrganisationId,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_OrganisationModel.toModel(dto));
  },
  /**  */
  async lookupAllOrganisations(request: LookupAllOrganisationsRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-lookup-all-organisations'] ?? 'tdg/widget/organisations/lookup';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Int64LookupListResultModel.toModel(dto));
  },
  /**  */
  async getOrganisationForUser(request: GetOrganisationForUserRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-organisation-for-user'] ?? 'tdg/admin/organisations/My';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_OrganisationUpdateModel.toModel(dto));
  },
  /**  */
  async getOrganisations(request: GetOrganisationsRequestModel, config?: RequestConfig) {
    const requestDTO = GetOrganisationsRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-organisations'] ?? 'tdg/admin/organisations';
    const response = await service.get<any>(endpointPath, {
      query: {
        eventIdentifier: requestDTO.eventIdentifier,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_OrganisationListPagingResultModel.toModel(dto));
  },
  /**  */
  async getOrganisation(request: GetOrganisationRequestModel, config?: RequestConfig) {
    const requestDTO = GetOrganisationRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-organisation'] ?? 'tdg/admin/organisations/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_OrganisationUpdateModel.toModel(dto));
  },
  /**  */
  async putOrganisation(request: PutOrganisationRequestModel, config?: RequestConfig) {
    const requestDTO = PutOrganisationRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-put-organisation'] ?? 'tdg/admin/organisations/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.put<any>(endpointPath, {
      body: {
        id: requestDTO.id,
        links: requestDTO.links,
        creatorId: requestDTO.creatorId,
        creatorName: requestDTO.creatorName,
        created: requestDTO.created,
        modifierId: requestDTO.modifierId,
        modifierName: requestDTO.modifierName,
        modified: requestDTO.modified,
        externalId: requestDTO.externalId,
        organisationName: requestDTO.organisationName,
        logoDocumentId: requestDTO.logoDocumentId,
        membersCount: requestDTO.membersCount,
        organisationContactSalutation: requestDTO.organisationContactSalutation,
        organisationContactFirstName: requestDTO.organisationContactFirstName,
        organisationContactLastName: requestDTO.organisationContactLastName,
        organisationContactPhoneNumber: requestDTO.organisationContactPhoneNumber,
        organisationContactEmail: requestDTO.organisationContactEmail,
        organisationStreet: requestDTO.organisationStreet,
        organisationHouseNumber: requestDTO.organisationHouseNumber,
        organisationZIP: requestDTO.organisationZIP,
        organisationCity: requestDTO.organisationCity,
        acceptConditions: requestDTO.acceptConditions,
        organisationUserId: requestDTO.organisationUserId,
        isSupporter: requestDTO.isSupporter,
        logoDocumentExternalId: requestDTO.logoDocumentExternalId,
        userName: requestDTO.userName,
      },
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
  /**  */
  async lookup(request: LookupRequestModel, config?: RequestConfig) {
    const requestDTO = LookupRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-lookup'] ?? 'tdg/admin/organisations/lookup';
    const response = await service.get<any>(endpointPath, {
      query: {
        eventIdentifier: requestDTO.eventIdentifier,
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Int64LookupListResultModel.toModel(dto));
  },
});
